<template>
  <header>
    <div
      class="column loginId"
      @click="$emit('sort-by-column', 'loginId')"
    >
      <div>Login ID</div>
      <SortArrow
        v-if="columnSortedBy.loginId.display"
        :ascending="sortByAscending"
      />
    </div>

    <div
      class="column password"
      @click="$emit('sort-by-column', 'password')"
    >
      <div>Password</div>
      <SortArrow
        v-if="columnSortedBy.password.display"
        :ascending="sortByAscending"
      />
    </div>

    <div
      class="column security-answer"
      @click="$emit('sort-by-column', 'securityAnswer')"
    >
      <div>Security Answer</div>
      <SortArrow
        v-if="columnSortedBy.securityAnswer.display"
        :ascending="sortByAscending"
      />
    </div>

    <div
      class="column environment"
      @click="$emit('sort-by-column', 'environment')"
    >
      <div>Environment</div>
      <SortArrow
        v-if="columnSortedBy.environment.display"
        :ascending="sortByAscending"
      />
    </div>

    <div
      class="column notes"
      @click="$emit('sort-by-column', 'notes')"
    >
      <div>Notes</div>
      <SortArrow
        v-if="columnSortedBy.notes.display"
        :ascending="sortByAscending"
      />
    </div>

    <div class="column info">
      <div>Info</div>
    </div>

    <div class="actions"></div>
  </header>
</template>

<script>
  import SortArrow from '@/components/assets/SortArrow.vue'

  export default {
    name: 'UsersHeader',
    components: {
      SortArrow
    },
    props: {
      columnSortedBy: {
        type: Object,
        required: true
      },
      sortByAscending: {
        type: Boolean,
        required: true
      },
      sortByColumn: {}
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  @import '../../assets/styles/colors';
  @import '../../assets/styles/mixin';
  @import '../../assets/styles/tables';

  header > div:not(.actions) {

    &.security-answer, &.notes, &.password, &.info {
      display: none;
    }

    &.loginId {
      flex-basis: 100%;
    }
  }

  @media (min-width: 600px) {

    header > div:not(.actions) {

      &.loginId {
        flex-basis: 27%;
      }

      &.security-answer, &.notes, &.password {
        display: flex;
      }

      &.info {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user/UsersHeader.vue